export default class Chip {
  init() {
    document.querySelectorAll(".Chips").forEach((chip) => {
      chip.addEventListener("click", (event) => {
        chip.style.display = "none";
      });
    });
  }
}
